import TaskCentre from './model';

export default TaskCentre;



// WEBPACK FOOTER //
// ./data/Tasks/TaskCentre/index.js